import React from 'react';
import classNames from 'classnames';

import type { DateInput } from 'interface/common';
import { getFormattedDate, isDateToday } from 'utils/date';
import { WEEK_DAY_DISPLAY_FORMAT, MONTH_DISPLAY_FORMAT, DAY_DISPLAY_FORMAT } from 'constants/appConstants';

type DateBadgeVariant = 'event' | 'holiday';

interface DateBadgeRowProps {
  date?: DateInput;
  title?: React.ReactNode;
  pillLabel: React.ReactNode;
  variant?: DateBadgeVariant;
  className?: string;
  childRef?: (node?: Element | null) => void;
  children?: React.ReactNode;
}

const DateBadgeRow: React.FC<DateBadgeRowProps> = ({
  date = '',
  title,
  pillLabel,
  variant = 'holiday',
  className,
  childRef,
  children,
}) => {
  const weekDay = getFormattedDate(date, WEEK_DAY_DISPLAY_FORMAT);
  const day = getFormattedDate(date, DAY_DISPLAY_FORMAT);
  const month = getFormattedDate(date, MONTH_DISPLAY_FORMAT);
  const isToday = isDateToday(date);

  return (
    <div ref={childRef} className={classNames('event__item d-flex', `event__item--${variant}`, className)}>
      <div className={classNames('event__date', 'text-align--center', { 'event__date--active': isToday })}>
        <div className="event__date--day">{weekDay}</div>
        <div className={classNames('event__date--dates', { 'event__date--active': isToday })}>{day}</div>
        <div className="event__date--month">{month}</div>
      </div>
      <div className="event__description">
        {children ?? <div className="event__title word-break">{title}</div>}

        <div className={classNames('event__type', isToday ? 'event__type--active' : `event__type--${variant}`)}>
          {pillLabel}
        </div>
      </div>
    </div>
  );
};

export default DateBadgeRow;
